import React, { Component, Ref } from "react";
import { _ReactPixi, Container, Graphics, withPixiApp } from "@inlet/react-pixi";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import withCanvasAutoplayForMobileConfiguration from "./configuration/withCanvasAutoplayForMobileConfiguration";
import UIManager from "../../core/components/ui/UiBuilder";
import { actions as autoplayActions } from "../../core/reducers/autoplayReducer";
import { actions as layoutssActions } from "../../core/reducers/layoutsStateReducer";
import { isMobile } from "react-device-detect";
//import * as PIXI from "pixi.js";
import { actions as buttonActions } from "../../core/reducers/buttonPanelReducer";
import { actions as baseGameActions } from "../../core/reducers/baseGameReducer";
import { actions as asyncActions } from "../../core/reducers/asyncServerResponseReducer";
import { actions as winpresentationAction } from "../../core/reducers/winPresentationReducer";
import { configGame } from "../../data/config";
import { actions as reelsActions } from "../../core/reducers/reelsStateReducer";
import { actions as gridsActions } from "../../core/reducers/gridStateReducer";
import { actions as reelgridActions } from "../../core/reducers/reelgridStateReducer";
import { Texture } from "pixi.js";
import { actions as behaviourAction } from "../../gamereducer/behaviourReducer";
import { actions as autoplayKeyboardListenerAction } from "../../gamereducer/autoplayKeyboardListenerReducer";
import { actions as aplicationActions } from "../../core/reducers/applicationStateReducer";
import { CURRENCY, TIMER } from "../../core/utills";

import * as PIXI from 'pixi.js';
import 'pixi-text-input';
import _ from "lodash";
// import 'pixi-keyboard'; // side effect import
interface IStore {
    [x: string]: any;
}

interface IProps {
    [x: string]: any;


}

interface IStateToProps {

}

interface IDispatchToProps {

}

interface IState {
    [x: string]: any;
}

class CanvasAutoplayForMobile extends Component<IProps, IState> {

    protected app: PIXI.Application;
    protected canvasAutoplayForMobileContainer: any
    protected ui_mode: string;
    protected displayUI: any;
    protected data: any;
    protected dragging: any;
    protected x: any;
    protected y: any;
    protected parent: any;
    protected autoplayMainContainer: any;
    protected button1: number = 0;
    protected button2: number = 0;
    protected button3: number = 0;
    protected button4: number = 0;
    protected button5: number = 0;
    protected button6: number = 0
    protected button7: number = 50;
    protected button8: number = 75;
    protected button9: number = 100;
    protected storeLastClickedButtonValue: number = 0;
    protected sliderBarGraphicColor: any = 0xDE3249;
    protected sliderBarGraphicAlpha: any = 0.001;
    public valueOfSlider: number = 1;
    public initialXOfSliderDot: number = 400;
    public extraWidthValue: number = 9;
    protected valueMultiplierForFirstSlide: number = 500;
    protected valueMultiplierForSecondSlide: number = 5000;
    protected sliderLineHeight: number = 20;
    protected sliderLineY: number = 4;
    protected a: number = 0;
    public sliderDotName: any;
    public sliderLineName: any;
    public selectedInputName: any;
    public maxValue: any;
    public lastHighlightedButton: any;
    private betMulitiplier = [0, 5, 10, 20, 50];
    private autoplayValues = this.props.autoplayList;
    public autoplayCountIndex: any;
    constructor(props: IProps) {
        super(props);
        this.app = props.app;
        this.state = {
            buttonPanelEnable: true,
            allContainerList: [],
            autoplayModeOn: false,
            showOverLay: false,
            isSpinning: false,
            pause: false,
            play: true,
            basegameIdleMode: true,
            basegamePlayMode: false,
            uiElements: [],
            lang: "en",
            toggleOn: false,
            slideAlpha: 0
        }
        this.canvasAutoplayForMobileContainer = React.createRef();
        if (isMobile) {
            this.ui_mode = "mobile";
        } else {
            this.ui_mode = "desktop";
        }

        this.displayUI = this.props.data.COMPONENTS.filter(this.checkUiMode.bind(this));

    }

    checkUiMode(uimodeobj: any) {

        if (uimodeobj.uimode === undefined) {
            uimodeobj.uimode = "both";
        }
        if (uimodeobj.uimode === "both" || uimodeobj.uimode === this.ui_mode) {
            return uimodeobj;
        }
    }

    selectMaxValue(dotName: any) {
        if (dotName === "sliderDot") {
            this.maxValue = (this.props.betList[this.props.currentBetIndex]) / 100 * this.valueMultiplierForFirstSlide;
        } else if (dotName === "sliderDot_2") {
            this.maxValue = (this.props.betList[this.props.currentBetIndex]) / 100 * this.valueMultiplierForSecondSlide;

        } else if (dotName === "sliderDot_3") {
            this.maxValue = this.props.transitionBalance / 100;
        }
    }

    bindUI() {
        //this.layoutChange(this.props.layoutMode);
        //this.addTextInputFields();
    }

    rangeSlider(dotName: any, sliderName: any) {
        UIManager.getRef(dotName).on('pointerdown', this.onDragStart.bind(this))
            .on('pointerup', this.onDragEnd.bind(this))
            .on('pointerupoutside', this.onDragEnd.bind(this))
            .on('pointermove', this.onDragMove.bind(this, dotName, sliderName));

        //     UIManager.getRef("firstInputBoxGraphic").on('keydown', this.keyDown.bind(this))
        //         .on('keyup', this.keyDown.bind(this))
        //         .on('keyupoutside', this.keyDown.bind(this))
        //         .on('keymove', this.keyDown.bind(this, dotName, sliderName));
    }


    onDragStart(event: any) {
        this.sliderDotName = event.target.name;
        this.selectedInputName = event.target.name + '_inputBoxText';
        this.sliderLineName = event.target.name + 'Line';
        this.selectMaxValue(this.sliderDotName);
        this.data = event.data;
        this.dragging = true;
        this.x = this.data.global.x;
    }

    onDragEnd() {
        this.dragging = false;
        this.data = null;
    }

    onDragMove(dotName: any, sliderName: any) {

        if (this.dragging) {
            this.setState((prevState) => {
                return {
                    ...prevState,
                    slideAlpha: this.state.slideAlpha + 1
                }
            })
            const newPosition = this.data.global;
            if (newPosition.x < this.initialXOfSliderDot) {
                newPosition.x = this.initialXOfSliderDot;
            } else if (newPosition.x > (UIManager.getRef(sliderName).width - this.extraWidthValue) + this.initialXOfSliderDot) {
                newPosition.x = (UIManager.getRef(sliderName).width - this.extraWidthValue) + this.initialXOfSliderDot;
            }
            this.x = newPosition.x;
            UIManager.getRef(this.sliderDotName).x = newPosition.x;

            this.valueOfSlider = this.x - this.initialXOfSliderDot;
            let displayValue = 0;
            displayValue = this.maxValue / (UIManager.getRef(sliderName).width - this.extraWidthValue) * (this.valueOfSlider);

            if (this.sliderDotName == "sliderDot_3") {
                UIManager.setText(this.selectedInputName, (displayValue.toFixed(2)));
                if (displayValue > 0) {
                    this.props.setBalanceDecreasedBy((displayValue.toFixed(2)));
                }
            }
            else {
                UIManager.setText(this.selectedInputName, Math.round(displayValue));
                if (this.sliderDotName == "sliderDot") {
                    if (displayValue > 0) {
                        this.props.setSingleWinExceed(Math.round(displayValue));
                    }
                }
                if (this.sliderDotName == "sliderDot_2") {
                    if (displayValue > 0) {
                        this.props.setBalanceIncreasedBy(Math.round(displayValue));
                    }
                }
            }

        }



    }

    sliderBarVisibilityOnOff() {
        this.sliderBarVisibility("sliderDot", "sliderDotLine");
        this.sliderBarVisibility("sliderDot_2", "sliderDot_2Line");
        this.sliderBarVisibility("sliderDot_3", "sliderDot_3Line");
    }

    buttonModeOnForDots() {
        UIManager.getRef("sliderDot").buttonMode = true;
        UIManager.getRef("sliderDot_2").buttonMode = true;
        UIManager.getRef("sliderDot_3").buttonMode = true;
    }

    componentDidMount() {
        this.bindUI();
        if (this.props.showAutoplay) {

            UIManager.getRef("autoplay_StartButton").interactive = false;
            UIManager.getRef("autoplay_StartButton").texture = Texture.from("autoplay_down.png");
            this.buttonModeOnForDots();

            UIManager.getRef("sliderDot").x = this.initialXOfSliderDot;
            this.rangeSliderCall();
            this.sliderBarVisibilityOnOff();
            this.switchControl(this.props.handMode);
            if (this.props.stopAutoplayOnAnyWin) {
                // this.radioButtonClicked("radioButtonOff", "radioButtonOn");
                UIManager.getRef("radioButtonOff").visible = false;
                UIManager.getRef("radioButtonOn").visible = true;
            } else {
                //this.radioButtonClicked("radioButtonOn", "radioButtonOff");
                UIManager.getRef("radioButtonOff").visible = true;
                UIManager.getRef("radioButtonOn").visible = false;
            }
            UIManager.getRef("radioButtonOnAnyWin_Portrait").visible = this.props.stopAutoplayOnAnyWin;
            UIManager.getRef("radioButtonOffOnAnyWin_Portrait").visible = !this.props.stopAutoplayOnAnyWin;
            UIManager.getRef("radioButtonOnOnFeature_Portrait").visible = !this.props.stopAutoplayOnFreegame;
            UIManager.getRef("radioButtonOffOnFeature_Portrait").visible = this.props.stopAutoplayOnFreegame;
            this.addInputTextFieldToContainers()

            this.strokeButtonRotate();
            UIManager.setText("autoplay_count", 10);
            this.props.setValueOfNumberButton(9);
            this.setTextOfButons();


        }


    }


    setTextOfButons() {
        //  for (let i = 1; i <= this.props.autoplayList.length; i++) {
        //      if (i == this.props.autoplayList.length) {
        //
        //          if (this.props.maximumAutoplay == 0) {
        //              UIManager.getRef("autoplayButton" + i).children[0].text = this.props.autoplayList[i - 1];
        //          }
        //          else {
        //              UIManager.getRef("autoplayButton" + i).children[0].text = this.props.maximumAutoplay;
        //          }
        //      }
        //      else {
        //          UIManager.getRef("autoplayButton" + i).children[0].text = this.props.autoplayList[i - 1];
        //      }
        //      //  UIManager.setText("autoplayButton" + i, this.props.autoplayList[i - 1]);
        //
        //
        // }
    }
    componentDidUpdate() {
        if (isMobile) {
            if (!this.props.showAutoplay) {
                UIManager.getRef("canvasAutoplayForMobileContainer").visible = false;
            }
            else {
                UIManager.getRef("canvasAutoplayForMobileContainer").visible = true;

                this.autoplayCountIndex = 1;

                this.strokeButtonRotate();

                UIManager.setText("autoplay_count", this.autoplayValues[1]);
                this.props.setValueOfNumberButton(this.autoplayValues[1]);



            }

            if (this.props.showAutoplay) {

                this.layoutChange(this.props.layoutMode);
            }
        }

        if (!isMobile) {
            UIManager.getRef("canvasAutoplayForMobileContainer").visible = false;
        }
        // UIManager.getRef("radioButtonOnAnyWin_Portrait").visible = this.props.stopAutoplayOnAnyWin;
        // UIManager.getRef("radioButtonOffOnAnyWin_Portrait").visible = !this.props.stopAutoplayOnAnyWin;
        // UIManager.getRef("radioButtonOnOnFeature_Portrait").visible = !this.props.stopAutoplayOnFreegame;
        // UIManager.getRef("radioButtonOffOnFeature_Portrait").visible = this.props.stopAutoplayOnFreegame;
        this.setRadiobuttonState();


    }

    setRadiobuttonState() {
        let timerAuto = TIMER.TimerManager.createTimer(50);
        timerAuto.on('end', (e: any) => {
            if (UIManager.getRef("radioButtonOnOnFeature_Portrait")) {
                UIManager.getRef("radioButtonOnOnFeature_Portrait").visible = this.props.stopAutoplayOnFreegame;
                UIManager.getRef("radioButtonOffOnFeature_Portrait").visible = !this.props.stopAutoplayOnFreegame;
                UIManager.getRef("radioButtonOnAnyWin_Portrait").visible = this.props.stopAutoplayOnAnyWin;
                UIManager.getRef("radioButtonOffOnAnyWin_Portrait").visible = !this.props.stopAutoplayOnAnyWin;
            }

        })
        timerAuto.start();
    }
    addInputTextFieldToContainers() {
        let lossLimitContainer = UIManager.getRef("lossLimit__Container");
        if (lossLimitContainer) {
            this.addTextInputFields(lossLimitContainer, 624, 270);
        }

        let winLimitContainer = UIManager.getRef("winLimit__Container");
        if (winLimitContainer) {
            this.addTextInputFields(winLimitContainer, 624, 270);
        }

        let singleWinLimitContainer = UIManager.getRef("singleWinLimit__Container");
        if (singleWinLimitContainer) {
            this.addTextInputFields(singleWinLimitContainer, 655, 270);
        }
    }

    rangeSliderCall() {
        this.rangeSlider("sliderDot", "sliderDotLine");
        this.rangeSlider("sliderDot_2", "sliderDot_2Line");
        this.rangeSlider("sliderDot_3", "sliderDot_3Line");
    }

    sliderBarVisibilityForInput(sliderDot: any, sliderLine: any) {
        const thing = new PIXI.Graphics();
        thing.beginFill(this.sliderBarGraphicColor);
        thing.drawRect(0, this.sliderLineY, UIManager.getRef(sliderDot).x - this.initialXOfSliderDot, this.sliderLineHeight);
        thing.endFill();
        UIManager.getRef(sliderLine).addChild(thing);
        thing.x = 0;
        thing.y = 0;
        thing.alpha = this.sliderBarGraphicAlpha;
        UIManager.getRef(sliderLine).mask = thing;

    }

    sliderBarVisibility(sliderDot: any, sliderLine: any) {
        const thing = new PIXI.Graphics();
        thing.beginFill(this.sliderBarGraphicColor);
        thing.drawRect(0, this.sliderLineY, UIManager.getRef(sliderDot).x - this.initialXOfSliderDot, this.sliderLineHeight);
        thing.endFill();
        UIManager.getRef(sliderLine).addChild(thing);
        thing.x = 0;
        thing.y = 0;
        thing.alpha = this.sliderBarGraphicAlpha;
        UIManager.getRef(sliderLine).mask = thing;

    }

    layoutChange(currentLayout: string) {
        this.displayUI.map((data: any, j: number) => {
            if (data.layout === true) {
                this.props.setApplicationLayoutObject(data.name);
            }
        }
        )
        this.setRadiobuttonState();
        this.strokeButtonRotate();
    }
    correctCurrencyCodeXAF(amount:string){
        if ((window as any).GAME_INFO.currency == "XAF" ) {
            return amount.replace('F','FCFA');
        }
        if((window as any).GAME_INFO.currency == "XOF"){
            return amount.replace('F','XOF');
        }
        return amount;
     }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {

        if (nextProps.showAutoplay !== this.props.showAutoplay) {

            if (nextProps.showAutoplay) {
                let timerAuto = TIMER.TimerManager.createTimer(100);
                timerAuto.on('end', (e: any) => {

                    let text = CURRENCY.CurrencyManager.formatCurrencyString(0, true, true, true, true);
                    text=this.correctCurrencyCodeXAF(text);
                    if (UIManager.getRef("funText1")) {
                        // UIManager.getRef("funText1").text = text;

                        // UIManager.getRef("funText2").text = text;

                        // UIManager.getRef("funText3").text = text;
                        UIManager.setText("funText1", text);
                        UIManager.setText("funText2", text);
                        UIManager.setText("funText3", text);
                    }


                })
                timerAuto.start();

            }
            return true;
        }


        if (nextProps.showAutoplay && nextProps.layoutMode !== this.props.layoutMode) {
            this.layoutChange(nextProps.layoutMode)
            return false;
        }

        if (nextProps.autoplayCount !== this.props.autoplayCount) {
            if (nextProps.autoplayCount == 0) {
                this.props.setBalanceIncreasedBy(-1);
                this.props.setBalanceDecreasedBy(-1);
                this.props.setSingleWinExceed(-1);
            }
            return false;
        }

        if (nextState.slideAlpha !== this.state.slideAlpha) {
            this.sliderBarVisibility(this.sliderDotName, this.sliderLineName);
            return false;
        }

        if (nextProps.handMode !== this.props.handMode) {
            this.switchControl(nextProps.handMode)
        }

        if (nextProps.digitToDisplay !== this.props.digitToDisplay) {

            /* if (nextProps.clickedInputBox == "inputBox_1") {
    
                this.x = nextProps.digitToDisplay - this.initialXOfSliderDot;
                UIManager.setText("sliderDot_inputBoxText", "");
                UIManager.setText("sliderDot_inputBoxText", nextProps.digitToDisplay);
    
                if (nextProps.digitToDisplay > 0) {
                    this.props.setSingleWinExceed(Math.floor(nextProps.digitToDisplay));
                }
    
            }
            else if (nextProps.clickedInputBox == "inputBox_2") {
                UIManager.setText("sliderDot_2_inputBoxText", "");
                UIManager.setText("sliderDot_2_inputBoxText", nextProps.digitToDisplay);
                if (nextProps.digitToDisplay > 0) {
                    this.props.setBalanceIncreasedBy(Math.floor(nextProps.digitToDisplay));
                }
            }
    
            else if (nextProps.clickedInputBox == "inputBox_3") {
                UIManager.setText("sliderDot_3_inputBoxText", "");
                UIManager.setText("sliderDot_3_inputBoxText", nextProps.digitToDisplay);
                if (nextProps.digitToDisplay > 0) {
                    this.props.setBalanceDecreasedBy((nextProps.digitToDisplay.toFixed(2)));
                }
            } */
            return false;
        }

        return false;
    }

    switchControl(handMode: any) {
        let autoStartBtn = UIManager.getRef("autoplay_StartButton");
        if (autoStartBtn) {
            if (handMode === 'right') {
                autoStartBtn.x = 1684;
                autoStartBtn.y = 909;
            } else {
                autoStartBtn.x = 155;
                autoStartBtn.y = 909;
            }
        }
    }

    onClick(e: any, buttonName: any, value: number) {
        UIManager.getRef("autoplayButton1").texture = Texture.from("land_autoplay_btn_deselected.png");
        UIManager.getRef("autoplayButton2").texture = Texture.from("land_autoplay_btn_deselected.png");
        UIManager.getRef("autoplayButton3").texture = Texture.from("land_autoplay_btn_deselected.png");
        UIManager.getRef("autoplayButton4").texture = Texture.from("land_autoplay_btn_deselected.png");
        UIManager.getRef("autoplayButton5").texture = Texture.from("land_autoplay_btn_deselected.png");


        e.target.texture = Texture.from("land_autoplay_btn_selected.png");
        UIManager.getRef("autoplay_StartButton").interactive = true;
        this.props.setValueOfNumberButton(value - 1);
        this.props.interactivityOfStartButton(true);

        this.storeLastClickedButtonValue = this.props.numberButtonValue;
    }

    onLossLimitClick(e: any, buttonName: any, value: number) {
        UIManager.getRef("LossLimitBtn1").texture = Texture.from("land_autoplay_btn_deselected.png");
        UIManager.getRef("LossLimitBtn2").texture = Texture.from("land_autoplay_btn_deselected.png");
        UIManager.getRef("LossLimitBtn3").texture = Texture.from("land_autoplay_btn_deselected.png");
        UIManager.getRef("LossLimitBtn4").texture = Texture.from("land_autoplay_btn_deselected.png");
        UIManager.getRef("LossLimitBtn5").texture = Texture.from("land_autoplay_btn_deselected.png");

        e.target.texture = Texture.from("land_autoplay_btn_selected.png");
        UIManager.getRef("autoplay_StartButton").interactive = true;
        //this.props.setValueOfNumberButton(value - 1);
        this.props.interactivityOfStartButton(true);

        this.storeLastClickedButtonValue = this.props.numberButtonValue;
        let displayValue = this.props.coinList[this.props.selectedCoin] * value
        //   UIManager.getRef('lossLimit__Container').getChildByName("lossLimit__Container_text_field").text = displayValue.toFixed(2)
        //UIManager.setText("lossLimit__Container_text_field", displayValue.toFixed(2));
        // let text = "FUN" + value + ".00";
        let text = CURRENCY.CurrencyManager.formatCurrencyString(value, true, true, true, true);
        text=this.correctCurrencyCodeXAF(text);
        UIManager.setText("funText1", text);
        this.props.setBalanceDecreasedBy((displayValue));
    }
    onWinLimitClick(e: any, buttonName: any, value: number) {
        UIManager.getRef("winLimitBtn1").texture = Texture.from("land_autoplay_btn_deselected.png");
        UIManager.getRef("winLimitBtn2").texture = Texture.from("land_autoplay_btn_deselected.png");
        UIManager.getRef("winLimitBtn3").texture = Texture.from("land_autoplay_btn_deselected.png");
        UIManager.getRef("winLimitBtn4").texture = Texture.from("land_autoplay_btn_deselected.png");
        UIManager.getRef("winLimitBtn5").texture = Texture.from("land_autoplay_btn_deselected.png");


        e.target.texture = Texture.from("land_autoplay_btn_selected.png");
        UIManager.getRef("autoplay_StartButton").interactive = true;
        //this.props.setValueOfNumberButton(value - 1);
        this.props.interactivityOfStartButton(true);

        this.storeLastClickedButtonValue = this.props.numberButtonValue;
        let displayValue = this.props.coinList[this.props.selectedCoin] * value
        //UIManager.setText("sliderDot_2_inputBoxText", displayValue.toFixed(2));
        // UIManager.getRef('winLimit__Container').getChildByName("winLimit__Container_text_field").text = displayValue.toFixed(2)
        //let text = "FUN" + value + ".00";
        let text = CURRENCY.CurrencyManager.formatCurrencyString(value, true, true, true, true);
        text=this.correctCurrencyCodeXAF(text);
        UIManager.setText("funText2", text);
        this.props.setBalanceIncreasedBy(Math.floor(displayValue));
    }

    singleWinLimitClick(e: any, buttonName: any, value: number) {
        UIManager.getRef("singleWinLimitBtn1").texture = Texture.from("land_autoplay_btn_deselected.png");
        UIManager.getRef("singleWinLimitBtn2").texture = Texture.from("land_autoplay_btn_deselected.png");
        UIManager.getRef("singleWinLimitBtn3").texture = Texture.from("land_autoplay_btn_deselected.png");
        UIManager.getRef("singleWinLimitBtn4").texture = Texture.from("land_autoplay_btn_deselected.png");
        UIManager.getRef("singleWinLimitBtn5").texture = Texture.from("land_autoplay_btn_deselected.png");

        e.target.texture = Texture.from("land_autoplay_btn_selected.png");
        UIManager.getRef("autoplay_StartButton").interactive = true;
        //this.props.setValueOfNumberButton(value - 1);
        this.props.interactivityOfStartButton(true);

        this.storeLastClickedButtonValue = this.props.numberButtonValue;
        let displayValue = this.props.coinList[this.props.selectedCoin] * value
        // let text = "FUN" + value + ".00";
        let text = CURRENCY.CurrencyManager.formatCurrencyString(value, true, true, true, true);
        text=this.correctCurrencyCodeXAF(text);
        UIManager.setText("funText3", text);
        //UIManager.getRef('singleWinLimit__Container').getChildByName("singleWinLimit__Container_text_field").text = displayValue.toFixed(2)
        this.props.setSingleWinExceed(Math.floor(displayValue));
    }

    disableSelectedButton(parentName: any) {
        switch (parentName) {
            case 'winLimit__Container':
                UIManager.getRef("winLimitBtn1").texture = Texture.from("land_autoplay_btn_deselected.png");
                UIManager.getRef("winLimitBtn2").texture = Texture.from("land_autoplay_btn_deselected.png");
                UIManager.getRef("winLimitBtn3").texture = Texture.from("land_autoplay_btn_deselected.png");
                UIManager.getRef("winLimitBtn4").texture = Texture.from("land_autoplay_btn_deselected.png");
                UIManager.getRef("winLimitBtn5").texture = Texture.from("land_autoplay_btn_deselected.png");
                this.props.setBalanceIncreasedBy(0);
                break;
            case 'singleWinLimit__Container':
                UIManager.getRef("singleWinLimitBtn1").texture = Texture.from("land_autoplay_btn_deselected.png");
                UIManager.getRef("singleWinLimitBtn2").texture = Texture.from("land_autoplay_btn_deselected.png");
                UIManager.getRef("singleWinLimitBtn3").texture = Texture.from("land_autoplay_btn_deselected.png");
                UIManager.getRef("singleWinLimitBtn4").texture = Texture.from("land_autoplay_btn_deselected.png");
                UIManager.getRef("singleWinLimitBtn5").texture = Texture.from("land_autoplay_btn_deselected.png");

                this.props.setSingleWinExceed(0);
                break;
            case 'lossLimit__Container':
                UIManager.getRef("LossLimitBtn1").texture = Texture.from("land_autoplay_btn_deselected.png");
                UIManager.getRef("LossLimitBtn2").texture = Texture.from("land_autoplay_btn_deselected.png");
                UIManager.getRef("LossLimitBtn3").texture = Texture.from("land_autoplay_btn_deselected.png");
                UIManager.getRef("LossLimitBtn4").texture = Texture.from("land_autoplay_btn_deselected.png");
                UIManager.getRef("LossLimitBtn5").texture = Texture.from("land_autoplay_btn_deselected.png");
                this.props.setBalanceDecreasedBy(0);
                break;
        }

    }

    setLimitOnFocusOut(parentName: any, value: any) {
        if (value > 0) {
            switch (parentName) {
                case 'winLimit__Container':
                    UIManager.getRef('winLimit__Container').getChildByName("winLimit__Container_text_field").text = value.toFixed(2)
                    this.props.setBalanceIncreasedBy(value);
                    break;
                case 'singleWinLimit__Container':
                    UIManager.getRef('singleWinLimit__Container').getChildByName("singleWinLimit__Container_text_field").text = value.toFixed(2)
                    this.props.setSingleWinExceed(value);
                    break;
                case 'lossLimit__Container':
                    UIManager.getRef('lossLimit__Container').getChildByName("lossLimit__Container_text_field").text = value.toFixed(2)
                    this.props.setBalanceDecreasedBy(value);
                    break;
            }
        }

    }

    addTextInputFields(parent: any, XPos: any, Ypos: any) {
        const TextInput = require('pixi-text-input')
        let inputTxtField = new TextInput({
            input: {
                fontFamily: 'Arial',
                fontSize: '20px',
                padding: '14px 24px',
                width: '140px',
                color: 'white',
                height: '35px'
            },
            box: this.generateBox
        })

        //inputTxtField.placeholder = 'Enter your Text...'
        inputTxtField.name = parent.name + "_text_field"
        inputTxtField.x = XPos
        inputTxtField.y = Ypos

        let parentContainer = parent
        if (parentContainer) {
            parentContainer.addChild(inputTxtField)
            inputTxtField.on('keydown', (keycode: any) => {
                if (Number(inputTxtField.text) > this.props.coinList[this.props.selectedCoin] * 50) {

                }
            })

            inputTxtField.on('focus', (keycode: any) => {
                this.disableSelectedButton(parentContainer.name)

            })
            inputTxtField.on('blur', (keycode: any) => {
                //Number(inputTxtField.text).toFixed(2)
                this.setLimitOnFocusOut(parentContainer.name, Number(inputTxtField.text));

            })
        }
    }



    generateBox(w: any, h: any, state: any) {
        var box = new PIXI.Container()
        var sprite = UIManager.getRef('generateBoxFrame')
        var mask = new PIXI.Graphics()
        mask.beginFill(0x181818)
        mask.drawRect(0, 0, w, h)
        box.addChild(mask)
        if (sprite) {
            box.addChild(sprite)
            sprite.mask = mask

            switch (state) {
                case 'DEFAULT':
                    sprite.tint = 0xffffff
                    break;
                case 'FOCUSED':
                    sprite.tint = 0x7EDFFF
                    break;
                case 'DISABLED':
                    sprite.alpha = 0.5
                    break;
            }
        }

        return box
    }

    radioButtonClickedOnWin(currentButtonName: any, nextButtonName: any) {
        this.props.stoppedAutoplayOnWin();
        UIManager.getRef("radioButtonOnAnyWin_Portrait").visible = this.props.stopAutoplayOnAnyWin;
        UIManager.getRef("radioButtonOffOnAnyWin_Portrait").visible = !this.props.stopAutoplayOnAnyWin;
    }
    radioButtonClickedOnFeature(currentButtonName: any, nextButtonName: any) {
        this.props.stoppedAutoplayOnFreeGame();
        UIManager.getRef("radioButtonOnOnFeature_Portrait").visible = this.props.stopAutoplayOnFreegame;
        UIManager.getRef("radioButtonOffOnFeature_Portrait").visible = !this.props.stopAutoplayOnFreegame;
    }

    handleEvent = (e: any) => {
        //  UIManager.getRef("autoplay_StartButton").texture = Texture.from("autoplay_down.png");

        switch (e.target.name) {
            case "autoplayButton1":
                this.onClick(e, e.target.name, this.button1);
                return;
            case "autoplayButton2":
                this.onClick(e, e.target.name, this.button2);
                return;
            case "autoplayButton3":
                this.onClick(e, e.target.name, this.button3);
                return;
            case "autoplayButton4":
                this.onClick(e, e.target.name, this.button4);
                return;
            case "autoplayButton5":

                if (this.props.maximumAutoplay !== 0) {
                    this.button5 = this.props.maximumAutoplay;
                }


                this.onClick(e, e.target.name, this.button5);
                return;
            case "LossLimitBtn1":
                this.onLossLimitClick(e, e.target.name, this.betMulitiplier[0]);
                return;
            case "LossLimitBtn2":
                this.onLossLimitClick(e, e.target.name, this.betMulitiplier[1]);
                return;
            case "LossLimitBtn3":
                this.onLossLimitClick(e, e.target.name, this.betMulitiplier[2]);
                return;
            case "LossLimitBtn4":
                this.onLossLimitClick(e, e.target.name, this.betMulitiplier[3]);
                return;
            case "LossLimitBtn5":
                this.onLossLimitClick(e, e.target.name, this.betMulitiplier[4]);
                return;
            case "winLimitBtn1":
                this.onWinLimitClick(e, e.target.name, this.betMulitiplier[0]);
                return;
            case "winLimitBtn2":
                this.onWinLimitClick(e, e.target.name, this.betMulitiplier[1]);
                return;
            case "winLimitBtn3":
                this.onWinLimitClick(e, e.target.name, this.betMulitiplier[2]);
                return;
            case "winLimitBtn4":
                this.onWinLimitClick(e, e.target.name, this.betMulitiplier[3]);
                return;
            case "winLimitBtn5":
                this.onWinLimitClick(e, e.target.name, this.betMulitiplier[4]);
                return;
            case "singleWinLimitBtn1":
                this.singleWinLimitClick(e, e.target.name, this.betMulitiplier[0]);
                return;
            case "singleWinLimitBtn2":
                this.singleWinLimitClick(e, e.target.name, this.betMulitiplier[1]);
                return;
            case "singleWinLimitBtn3":
                this.singleWinLimitClick(e, e.target.name, this.betMulitiplier[2]);
                return;
            case "singleWinLimitBtn4":
                this.singleWinLimitClick(e, e.target.name, this.betMulitiplier[3]);
                return;
            case "singleWinLimitBtn5":
                this.singleWinLimitClick(e, e.target.name, this.betMulitiplier[4]);
                return;

            case "radioButtonOnAnyWin_Portrait":
                this.radioButtonClickedOnWin("radioButtonOnAnyWin_Portrait", "radioButtonOffOnAnyWin_Portrait");
                return;
            case "radioButtonOffOnAnyWin_Portrait":
                this.radioButtonClickedOnWin("radioButtonOffOnAnyWin_Portrait", "radioButtonOnAnyWin_Portrait");
                return;
            case "radioButtonOnOnFeature_Portrait":
                this.radioButtonClickedOnFeature("radioButtonOnOnFeature_Portrait", "radioButtonOffOnFeature_Portrait");
                return;
            case "radioButtonOffOnFeature_Portrait":
                this.radioButtonClickedOnFeature("radioButtonOffOnFeature_Portrait", "radioButtonOnOnFeature_Portrait");
                return;

            case "autoplay_StartButton":
                this.startAutoplay();
                return;
            case "autoplay_CancelButton":
                this.props.setAutoplayKeyboardListenerActive(false);
                this.props.setAllButtonEnable();
                this.props.hideAutoplay();
                this.props.setApplicationButtonpanelVisibility(true);
                //this.props.setDigitToDisplay(0);
                return;
            case "autoplayCount_increases":
                if (this.autoplayCountIndex <= 4) {
                    if (this.autoplayCountIndex == 4) {
                        this.autoplayCountIndex = this.autoplayCountIndex;
                    }
                    else {
                        this.autoplayCountIndex = this.autoplayCountIndex + 1;
                    }


                    if (this.props.maximumAutoplay == 0) {
                        UIManager.setText("autoplay_count", this.autoplayValues[this.autoplayCountIndex]);
                        this.props.setValueOfNumberButton(this.autoplayValues[this.autoplayCountIndex] - 1);

                    }
                    else {

                        if (this.autoplayCountIndex == 4) {
                            UIManager.setText("autoplay_count", this.props.maximumAutoplay);
                            this.props.setValueOfNumberButton(this.props.maximumAutoplay - 1);
                        }
                        else {
                            UIManager.setText("autoplay_count", this.autoplayValues[this.autoplayCountIndex]);
                            this.props.setValueOfNumberButton(this.autoplayValues[this.autoplayCountIndex] - 1);
                        }

                    }
                }

                return;
            case "autoplayCount_decreases":
                if (this.autoplayCountIndex >= 0) {

                    if (this.autoplayCountIndex == 0) {
                        this.autoplayCountIndex = this.autoplayCountIndex;
                    }
                    else {
                        this.autoplayCountIndex = this.autoplayCountIndex - 1;
                    }
                    UIManager.setText("autoplay_count", this.autoplayValues[this.autoplayCountIndex]);
                    this.props.setValueOfNumberButton(this.autoplayValues[this.autoplayCountIndex] - 1);
                }
                return;

            default:
                return 'No buttons';
        }
    }


    startAutoplay() {
        if (this.props.numberButtonValue == 0) {
            this.props.setValueOfNumberButton(9);
        }
        else {

        }
        if (this.props.balance - this.props.coinList[this.props.selectedCoin] < 0) {
            this.props.setInsufficientFunds(true);
            this.props.setAutoplayKeyboardListenerActive(false);
            this.props.setAllButtonEnable();
            this.props.hideAutoplay();
            this.props.setApplicationButtonpanelVisibility(true);

        } else {
            this.props.setAmountForAutoplay(Number(this.props.balance));
            this.props.hideAutoplay();
            this.props.setApplicationButtonpanelVisibility(true);
            // this.props.setAutoplayKeyboardListenerActive(false);
            this.props.setAutoplay(this.props.numberButtonValue);
            this.props.setApplicationAutoplayCount(this.props.numberButtonValue);
            this.props.startAutoplay();
            this.props.getApplicationSpinResponse();
            this.props.stopWinPresentation();
            this.props.resetReelState();
            this.props.setAllButtonDisable();
            this.props.interactivityOfStartButton(false);
            this.autoplayCountIndex = 0;
        }
    }
   


    strokeButtonRotate() {
        if (isMobile && window.innerWidth < window.innerHeight) {
            UIManager.getRef("autoplay_StartButtonStroke") && (UIManager.getRef("autoplay_StartButtonStroke").rotation = 1.56);
        }
        else if (isMobile && window.innerWidth > window.innerHeight) {
            UIManager.getRef("autoplay_StartButtonStroke") && (UIManager.getRef("autoplay_StartButtonStroke").rotation = 0);
        }
    }

    mouseOver() {
        //alert("mouseOver")
    }

    mouseOut = (e: any) => {

        /*  switch (e.currentTarget.name) {
             case "inputBox_1":
                 this.props.setAutoplayKeyboardListenerActive(false);
                 return;
             case "inputBox_2":
                 this.props.setAutoplayKeyboardListenerActive(false);
                 return;
             case "inputBox_3":
                 this.props.setAutoplayKeyboardListenerActive(false);
                 return;
     
             default:
                 return 'No buttons';
         } */
    }


    render() {

        if (!this.props.showAutoplay) {
            return (<></>)
        }

        return (
            <UIManager id={"canvasAutoplayForMobileContainer"} type={"Container"} ref={i => this.canvasAutoplayForMobileContainer = i} name={"canvasAutoplayForMobileContainer"}
                configGame={this.props.configGame}
                app={this.app}>
                {
                    this.displayUI && this.displayUI.map((i: any) =>
                        <UIManager key={`UIManager-${Math.random()}`} langObj={this.props.langObj} type={i.type}
                            id={i.id} {...i} app={this.app} configGame={this.props.configGame}
                            ClickHandler={this.handleEvent} mouseOver={this.mouseOver} mouseOut={this.mouseOut} touchend={this.handleEvent} scope={this} />

                    )

                }

            </UIManager>

        )
    }

}

export default withPixiApp(connect(
    (state: Pick<IStore, 'wrapperState' | 'autoplayState' | 'betPanelState' | 'applicationState' | 'basegameState' | 'behaviourState' | 'autoplayKeyBoardListenerState'>): IStateToProps =>
    ({
        showAutoplay: state.autoplayState.showAutoplay,
        layoutMode: state.applicationState.layoutMode,
        autoplayCount: state.basegameState.autoplayCount,
        currentBetIndex: state.basegameState.currentBetIndex,
        betList: state.basegameState.betList,
        numberButtonValue: state.autoplayState.numberButtonValue,
        stopAutoplayOnAnyWin: state.autoplayState.stopAutoplayOnAnyWin,
        stopAutoplayOnFreegame: state.autoplayState.stopAutoplayOnFreegame,
        transitionBalance: state.behaviourState.transitionBalance,
        selectedCoin: state.betPanelState.selectedCoin,
        coinList: state.betPanelState.coinList,
        handMode: state.applicationState.handMode,
        digitToDisplay: state.autoplayKeyBoardListenerState.digitToDisplay,
        clickedInputBox: state.autoplayKeyBoardListenerState.clickedInputBox,
        maximumAutoplay: state.wrapperState.maximumAutoplay,
        autoplayList: state.behaviourState.autoplayList,
        balance: state.basegameState.balance,
        
    }),
    (dispatch: Dispatch): IDispatchToProps => ({
        setApplicationLayoutObject: (layoutobjectlist: any): any => dispatch(layoutssActions.setApplicationLayoutObject(layoutobjectlist)),
        setValueOfNumberButton: (numberButtonValue: number): any => dispatch(autoplayActions.setValueOfNumberButton(numberButtonValue)),
        interactivityOfStartButton: (startButtonInteractivity: boolean): any => dispatch(autoplayActions.interactivityOfStartButton(startButtonInteractivity)),
        stoppedAutoplayOnWin: (): any => dispatch(autoplayActions.stoppedAutoplayOnWin()),
        stoppedAutoplayOnFreeGame: (): any => dispatch(autoplayActions.stoppedAutoplayOnFreeGame()),
        setAllButtonEnable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonEnable(exceptBtnList)),
        hideAutoplay: (): any => dispatch(autoplayActions.hideAutoplayUI()),
        setAutoplay: (autoplayCount: number): any => dispatch(autoplayActions.setAutoplayCount(autoplayCount)),
        startAutoplay: (): any => dispatch(baseGameActions.startAutoplay()),
        setApplicationAutoplayCount: (autoplaycount: number): any => dispatch(baseGameActions.setApplicationAutoplayCount(autoplaycount)),
        getApplicationSpinResponse: (): any => dispatch(asyncActions.getApplicationSpinResponse()),
        setAllButtonDisable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonDisable(exceptBtnList)),
        stopWinPresentation: (): any => dispatch(winpresentationAction.stopWinPresentation()),
        resetReelState: (): any => dispatch(Number(configGame["SPIN_TYPE"]) === 0 && reelsActions.resetReelState() || Number(configGame["SPIN_TYPE"]) === 1 && gridsActions.resetReelState() || Number(configGame["SPIN_TYPE"]) === 2 && reelgridActions.resetReelState()),
        autoplayReset: (resetAutoplay: boolean): any => dispatch(autoplayActions.autoplayReset(resetAutoplay)),
        setBalanceIncreasedBy: (value: any): any => dispatch(autoplayActions.setBalanceIncreasedBy(value)),
        setBalanceDecreasedBy: (value: any): any => dispatch(autoplayActions.setBalanceDecreasedBy(value)),
        setSingleWinExceed: (value: any): any => dispatch(autoplayActions.setSingleWinExceed(value)),
        setAmountForAutoplay: (storeAmountForAutoplay: any): any => dispatch(behaviourAction.setAmountForAutoplay(storeAmountForAutoplay)),
        setAutoplayKeyboardListenerActive: (autoplayKeyboardListenerActive: boolean): any => dispatch(autoplayKeyboardListenerAction.setAutoplayKeyboardListenerActive(autoplayKeyboardListenerActive)),
        setNameOfClickedInputBox: (clickedInputBox: any): any => dispatch(autoplayKeyboardListenerAction.setNameOfClickedInputBox(clickedInputBox)),
        setDigitToDisplay: (digitToDisplay: any): any => dispatch(autoplayKeyboardListenerAction.setDigitToDisplay(digitToDisplay)),
        setApplicationButtonpanelVisibility: (visible: boolean): any => dispatch(aplicationActions.setApplicationButtonpanelVisibility(visible)),
        setInsufficientFunds: (insuffFunds: any): any => dispatch(behaviourAction.setInsufficientFunds(insuffFunds)),

    }))(withCanvasAutoplayForMobileConfiguration(CanvasAutoplayForMobile)));